export const initialState = {
  isLoading: false,
  connection: null,
  subscriptionDetails: {
    subsciptionType: null,
    subscriptionName: null
  }
};
